module.exports = __webpack_public_path__ + "assets/roadmap-line-1.8168cf54.svg";